import React, { useState } from 'react'
import moment from 'moment';
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { deleteHolidayTypeDetailAsync, getHolidaysByIdAsync ,checkedState, unCheckedState,checkedAllState,unCheckedAllState,updateSorting} from './holidayTypeDetailSlice';
import { colors } from 'react-select/dist/declarations/src/theme';
import { Link } from 'react-router-dom';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { formatDateWithDateAndMonthName, getValueFromResource } from '../../../common/timeLiveFunction';
const itemClass = 'ms-1 ms-lg-0';

const HolidayTypeDetailItems = (props: any) => {

    const { holidayTypeDetailList, modelRef, t, onopenModal, oncloseModal, IsEdit, IsDelete } = props;
    const { isLoading, sortOrder, sortColumn,pageSize } = useAppSelector((state) => state.holidayTypeDetail);
       const { cultureInfoName, decimalPlaces } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    // const [pageSize,setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const date = moment(holidayTypeDetailList.HolidayDate).format('DD/MM/YYYY');
    const year = moment(holidayTypeDetailList.HolidayDate).format('YYYY');
   
   

    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
    const onEditClick = (AccountHolidayTypeDetailId: any) => {
        dispatch(getHolidaysByIdAsync(AccountHolidayTypeDetailId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }

    const onDeleteClick = (AccountHolidayTypeDetailId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteHolidayTypeDetailAsync(AccountHolidayTypeDetailId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Holiday deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, AccountHoliday: any) => {

    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }


    return (
        <>
           {holidayTypeDetailList.length === 0 ?
          <div className=''><p className='noDataFound mt-3'>
            {/* {t('No Record Found')} */}
            {getValueFromResource('No Record Found',dispatch, t)}

            </p>
                </div> :
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                        {/* {IsDelete && */}
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={holidayTypeDetailList.every((item: any) => item.isSelected === 0) ? false :
                                            (holidayTypeDetailList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        {/* } */}
                        <th style={{width:'15%'}}>
                            {/* {t('Year')} */}
                            {getValueFromResource('Year',dispatch, t)}

                        {sortColumn === 'holidayTypeDetail.HolidayDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "holidayTypeDetail.HolidayDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "holidayTypeDetail.HolidayDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "holidayTypeDetail.HolidayDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "holidayTypeDetail.HolidayDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{width:'75%'}}>
                            {/* {t('Holiday Name')} */}
                            {getValueFromResource('Holiday Name',dispatch, t)}

                        {sortColumn === 'HolidayName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "HolidayName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "HolidayName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "HolidayName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "HolidayName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{width:'15%'}}>
                            {/* {t('Date')} */}
                            {getValueFromResource('Date',dispatch, t)}

                        {sortColumn === 'HolidayDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "HolidayDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "HolidayDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "HolidayDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "HolidayDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-5 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {holidayTypeDetailList.length > 0 && holidayTypeDetailList.map((holidayTypeDetail: any, i: any) => (
                        <tr key={i}>
                            {/* {IsDelete && */}
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check "
                                            checked={holidayTypeDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, holidayTypeDetail.AccountHolidayTypeDetailId) }}

                                        />
                                    </div>
                                </td>
                            {/* } */}
                             <td>{moment(holidayTypeDetail.HolidayDate).format('YYYY')}</td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '  onClick={() => { onEditClick(holidayTypeDetail.AccountHolidayTypeDetailId) }}>
                                <span className="   d-block "
                                >{holidayTypeDetail.HolidayName}</span>
                            </td>
                            <td>
                                {/* {moment.parseZone(holidayTypeDetail.HolidayDate).format('DD/MM/YYYY')} */}
                                {formatDateWithDateAndMonthName(holidayTypeDetail.HolidayDate, cultureInfoName.toString())}

                            </td>
                            
                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}

                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                            {IsEdit &&
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => {
                                                                dispatch(getHolidaysByIdAsync(holidayTypeDetail.AccountHolidayTypeDetailId))
                                                                    .unwrap()
                                                                    .then((originalPromiseResult) => {
                                                                        onopenModal();
                                                                    })
                                                                    .catch((rejectedValueOrSerializedError) => {
                                                                    })
                                                            }}
                                                        >
                                                            <span className="menu-icon custom-menu">
                                                                <i className="bi bi-pencil fs-6 iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Edit')}`} */}
                                                                {getValueFromResource('Edit',dispatch, t)}

                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                           
                                            {IsDelete && IsEdit &&
                                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                                            }

                                            {IsDelete &&
                                                <>
                                                    <div className='menu-hover-bg-danger'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onDeleteClick(holidayTypeDetail.AccountHolidayTypeDetailId) }}>
                                                            <span className="menu-icon  custom-menu">
                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                {/* {`${t('Delete')}`} */}
                                                                {getValueFromResource('Delete',dispatch, t)}

                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>                                
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

                }
        </>
    )



 
}

export default HolidayTypeDetailItems